import axios from "axios";
import { CUSTOMER_API_BASE } from "../env";

export const keyLabelMap = {
  autopay: "Autopay",
  email: "Email",
  previousEmail: "Previous Email",
  creditCardSigned: "Credit Card Signed",
  creditCardAdded: "Credit Card Added",
  insuranceDocumentAdded: "Insurance Document Added",
};

export async function getCustomerNotes(customerId, token) {
  return axios.get(`${CUSTOMER_API_BASE}/customers/v1/${customerId}/notes`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function createCustomerNote(customerId, body, token) {
  return axios.post(
    `${CUSTOMER_API_BASE}/customers/v1/${customerId}/notes`,
    { ...body },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
}

export async function editCustomerNote(customerId, noteId, body, token) {
  return axios.put(
    `${CUSTOMER_API_BASE}/customers/v1/${customerId}/notes/${noteId}`,
    { ...body },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
}

export async function deleteCustomerNote(customerId, noteId, token) {
  return axios.delete(
    `${CUSTOMER_API_BASE}/customers/v1/${customerId}/notes/${noteId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/notes.js